<template>
    <div>
        <article class="layui-carousel" id="banner" lay-anim="" lay-indicator="inside" lay-arrow="hover"
            style="width: 100%; height: 600px;">
            <van-swipe class="index-swipe" :autoplay="5000" indicator-color="white">
                <van-swipe-item v-for="(item, index) in b_list" :key="index">
                    <img @click="bannerLink(item)" :src="item.imageUrl">
                </van-swipe-item>
            </van-swipe>
        </article>
        <!-- <section class="toppic layui-main">
            <a href="/product/3685">
                <div class="items">
                    <h3>产品中心</h3>
                    <p>激光表面处理及再制造应用解决方案提供商。</p>
                    <img src="https://res.baowugroup.com/wghglaser.com/public/themes/jiguang/public/assets/images/chanpin/homeChanpin1.jpg">
                </div>
            </a>
            <a href="/processing/3686">
                <div class="items">
                    <h3>加工中心</h3>
                    <p>承接激光表面处理及再制造加工业务。</p>
                    <img src="https://res.baowugroup.com/wghglaser.com/public//themes/jiguang/public/assets/images/chanpin/homeChanpin2.jpg">
                </div>
            </a>
        </section> -->
        <div class="index-product">
            <div class="layui-index">
                <div class="index_title">
                    <div class="en">PRODUCTS</div>
                    <div class="zh">产品中心</div>
                </div>
                <div class="product_item">
                    <div class="product_l">
                        
                        <div class="product_title">{{p_list[productIndex].nodeName}}</div>
                        <div class="product_content" v-html="p_list[productIndex].content"></div>
                        <div class="product_btn">
                            <a href="/product/3685" class="index_btn">
                                <span>查看详情</span>
                                <img src="../assets/Vector1@2x.png" alt="">
                            </a>
                            <a href="javascript:;" @click="goChat" style="margin-left: 10px;" class="index_btn">
                                <span>价格垂询</span>
                                <img src="../assets/Vector1@2x.png" alt="">
                            </a>
                        </div>
                    </div>
                    <div class="product_img">
                        <img :src="p_list[productIndex].imageUrl" alt="">
                    </div>
                    <div class="product_r">
                    <div class="index-product-item" v-for="(item, index) in p_list" :key="index" v-if="item.isShow!=0 && index<6">
                            <span @mouseenter="productChange(index)"><router-link :to="`/product/3685`">{{ item.nodeName }}</router-link></span>
                            <img src="../assets/Group1@2x.png" alt="">
                    </div>
                    <div><img class="Subtract" src="../assets/Subtract.png" alt=""></div>
                    </div>
                </div>
            </div>
        </div>
        <!-- <section class="layui-main product">
            <div class="site-title">
                <fieldset>
                    <legend><a name="fieldset">产品中心</a></legend>
                </fieldset>
            </div>
            <div class="product-box">
                <div class="product-bc" v-for="(item, index) in p_list" :key="index" v-if="item.isShow!=0">
                    <div> <a class="toper" :href="`/product/3685`">
                            <img :src="item.imageUrl" :alt="item.nodeName"></a> </div>
                    <div class="desc">
                        <a :href="`/product/3685`">
                            <h4>{{ item.nodeName }}</h4>
                        </a>
                        <a :href="`/product/3685`">
                            <p v-html="item.content "></p>
                        </a>
                        <a class="goabout" :href="`/product/3685`"> 了解产品 </a>
                    </div>
                </div>
            </div>
        </section>
        <section class="anli">
            <div class="site-title">
                <fieldset>
                    <legend><a name="fieldset">行业案例</a></legend>
                </fieldset>
            </div>
            <div class="anli-box layui-main" id="caseCtt">
                <div class="items" v-for="(item, index) in c_list" v-if="item?.contentGroups[0]?.contentGroupName =='pc'" :key="index">
                    <a :href="`/info/case/${item.node.nodeId}?id=${item.id}`"><img :src="item.imageUrl"
                            :alt="item.title"></a>
                    <div class="xinfo">
                        <a :href="`/info/case/${item.node.nodeId}?id=${item.id}`">
                            <h4 class="xol">{{ item.title }}</h4>
                        </a>
                        <a :href="`/info/case/${item.node.nodeId}?id=${item.id}`">
                            <div v-html="item.content"></div>
                        </a>
                    </div>
                </div>
            </div>
            <a id="caseMor" :href="`/case/3688`">更多案例 </a>
        </section> -->
        <section>
            <div class="layui-index ">
                <div class="case-index flexBox" style="justify-content: space-between;">
                    <div class="case_l flexBox">
                        <img class="case_img" src="../assets/case_img.png" alt="">
                        <div class="case_title_list">
                            <div class="index_title">
                                <div class="en">INDUSTRY CASE</div>
                                <div class="zh">行业案例</div>
                            </div>
                            <div class="case_description" style="color: #999;">毫无疑问，智能化是制造自动化的发展方向，在制造过程的各个环节几乎都广泛应用人工智能技术。</div>
                            <div class="case_title" v-for="(item, index) in c_list"  :key="index">
                                <a :href="`/info/case/${item.node.nodeId}?id=${item.id}`"><h4>{{ item.title }}</h4></a>
                            </div>
                        </div>
                    </div>
                    <div class="case_r" style="width: 570px; overflow: hidden;">
                        <van-swipe :autoplay="5000" indicator-color="white">
                            <van-swipe-item v-for="(page, index) in pages" :key="index">
                                <div class="page-container">
                                    <div class="image-row">
                                        <div class="image-container" v-for="(image, imageIndex) in page" :key="imageIndex">
                                            <a :href="`/info/case/${image.node.nodeId}?id=${image.id}`">
                                                <img :src="image.imageUrl" alt="Industry Image" class="image" />
                                                <div class="text-overlay">{{ image.title }}</div>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </van-swipe-item>
                        </van-swipe>
                    </div>
                </div>
            </div>
        </section>
        <section class="xinwen" style="padding: 70px 0; background: #f8f8fa;">
            <!-- <div class="site-title">
                <fieldset>
                    <legend><a name="fieldset">新闻中心</a></legend>
                </fieldset>
            </div> -->
            <div class="xinwen-nr layui-index">
                <a style="padding-top: 40px; width: 600px;" :target="h_info?.linkUrl ==''? '': '_blank'" :href="h_info?.linkUrl ==''? `/article/newsList/3690/${h_info?.node?.nodeId}?id=${h_info?.id}` : h_info?.linkUrl" class="xinwen-nrl">
                    <div>
                        <div>
                            <h4>{{ h_info?.addDate.split(" ")[0].slice(8) }}</h4>
                            <p>{{ h_info?.addDate.split(" ")[0].substring(0, 7) }}</p>
                        </div>
                        <img class="thumb" :src="h_info?.imageUrl">
                    </div>
                    <h5 class="xol">{{ h_info?.title }}</h5>
                    <p>{{ h_info?.summary }}</p>
                </a>
                <div class="xinwen-nrz" style="margin-left: 30px;">
                    <div class="index_title" style="margin: 0 0 30px 24px;">
                        <div class="en">NEWS CENTER</div>
                        <div class="zh">新闻中心</div>
                    </div>
                    <a :target="item.linkUrl ==''? '': '_blank'" :href="item.linkUrl ==''? `/article/newsList/3690/${item.node.nodeId}?id=${item.id}` : item.linkUrl" class="xinwen_t"
                        v-for="(item, index) in r_list" :key="index">
                        <div>
                            <h4>{{ item.addDate.split(" ")[0].slice(8) }}</h4>
                            <p>{{ item.addDate.split(" ")[0].substring(0, 7) }}</p>
                        </div>
                        <div>
                            <h5 class="xol">{{ item.title }}</h5>
                            <p class="xol">{{ item.summary }}</p>
                        </div>
                    </a>
                </div>
            </div>
        </section>
    </div>
</template>
<script>
import {
    API_GetNewsListddh, API_GetNewsListHot, API_contentList, API_GetChildMenuCon
} from "@/fetch/api"
import Vue from 'vue'
import { Swipe, SwipeItem } from 'vant'
Vue.use(Swipe)
Vue.use(SwipeItem)
export default {
    data () {
        return {
            h_info: null,
            b_list: [],
            r_list: [],
            p_list: [],
            c_list: [],
            c_list_carousel:[],
            productIndex: 0,
            pages: [],
        }
    },
    created () {
        this.getNewsListHot()
        this.getNewsListRecommend()
        this.getChildMenu(3685)
        this.getNewsList(3688)
        this.getNewsList(3759)
    },
    mounted () {
    },
    methods: {
        //数组拆分成二维
        chunkArray(array, size) {
            return array.reduce((result, item, index) => {
                const chunkIndex = Math.floor(index / size);
                if (!result[chunkIndex]) {
                result[chunkIndex] = [];
                }
                result[chunkIndex].push(item);
                return result;
            }, []);
        },
        //产品
        productChange(index){
            setTimeout(() => {
                this.productIndex = index
            }, 100); 
        },
        //热点
        getNewsListHot () {
            API_GetNewsListHot({
                pageNo: 0,
                pageSize: 1,
                nodeId: '3690'
            })
                .then(res => {
                    let { data } = res.data
                    this.h_info = data[0]
                })
                .catch(err => {
                    console.log(err)
                })

        },
        //推荐
        getNewsListRecommend () {
            API_GetNewsListddh({
                pageNo: 0,
                pageSize: 4,
                nodeId: '3690'
            })
                .then(res => {
                    let { data } = res.data
                    this.r_list = data
                })
                .catch(err => {
                    console.log(err)
                })
        },
        //行业案例
        getNewsList (nodeId) {
            API_contentList({
                pageNo: 0,
                pageSize: 20,
                nodeId: nodeId,
            })
                .then(res => {
                    let { data } = res.data
                    if (nodeId == 3688) {
                        let list = []
                        for (let i = 0; i < data.length; i++) {
                            if (data[i].contentGroups[0].contentGroupName =='pc') {
                                list.push(data[i])
                            }
                        }
                        this.c_list = list;
                        // this.c_list_carousel = this.chunkArray(list, 3);
                        this.pages = this.chunkArray(list, 3)
                    }else{
                        this.b_list = data
                    }
                })
                .catch(err => {
                    console.log(err)
                })
        },
        //产品
        getChildMenu (nodeId) {
            API_GetChildMenuCon({
                pageNo: 0,
                pageSize: 20,
                nodeId: nodeId
            })
                .then(res => {
                    let { childs } = res.data
                    let list = []
                    for (let i = 0; i < childs.length; i++) {
                        if (childs[i].isShow != 0) {
                            list.push(childs[i])
                        }
                    }
                    this.p_list = list
                })
                .catch(error => { })
        },
        //banner跳转
        bannerLink(item){
            let url = item.linkUrl
            if(url.includes("http")){
                window.location.href = url
            }else{
                this.$router.push({path:url})
            }
        },
        //咨询
        goChat () {
            window.open('https://affim.baidu.com/unique_68322204/chat?siteId=22055956&userId=68322204&siteToken=c535eec2a50b7ca323575b901eb961be')
        },
    }
}
</script>